<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<div class="modal-body">
    <p>{{message}}</p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="ok()"><i class="bi bi-check-circle"></i> Yes, please</button>
    <button type="button" class="btn btn-secondary" (click)="cancel()"><i class="bi bi-x-circle"></i> No, cancel</button>
</div>